import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useFoldersStore = defineStore('folders', {
  state,
  getters,
  actions
})

export default useFoldersStore
